import React, {lazy} from "react";
import PropTypes from 'prop-types';
import TabsScreenComponent from "./TabsComponent/TabsScreenComponent";
import ButtonScreenComponent from "./ButtonScreenComponent";
import LabelScreenComponent from "./LabelScreenComponent";
import LineScreenComponent from "./LineScreenComponent";
import FieldScreenComponent from "./FieldScreenComponent";
import ContainerArrayFields from "./ContainerArrayFields";
import FieldsInfinity from "./FieldsInfinity";
import ImageScreenComponent from "./ImageScreenComponent";
import CardScreenComponent from "./CardScreenComponent";
import Chat from "./Chat";
import TextScreenComponent from "./TextScreenComponent/TextScreenComponent";
import PanelScreenComponent from "./PanelScreenComponent";
import Survey from "./Survey";
import EmbeddedScreen from "./EmbeddedScreenComponent/EmbeddedScreen";
import StepperComponent from "./StepperComponent";
import ProgressComponent from "./ProgressComponent";
import SelectionCriteria from "./SelectionCriteria/SelectionCriteria";
import Feed from "./Feed";
import FeedPost from "./FeedPost";
import ForEachComponent from "./ForEachComponent/ForEachComponent";
import ActionsBar from "./Templates/ActionsBar/ActionsBar";
import BottomMenu from "./BottomMenu";
import CheckboxComponent from "./CheckboxComponent";
import DropzoneComponent from "./DropzoneComponent/index";
import IconComponent from "./IconComponent";
import SearchBarComponent from "./SearchBarComponent";
import Menu from "./Menu";
import BadgeComponent from "./BadgeComponent";
import RatingComponent from "./RatingComponent";
import RadioGroupComponent from "./RadioGroupComponent";
import BlockScreenComponent from "./BlockComponent";
import SwiperComponent from "./SwiperComponent/SwiperComponent";
import AccordionComponent from "./AccordionComponent/AccordionComponent";
import OptionsComponent from "./OptionsComponent";
import FullViewComponent from "./FullViewComponent";
import {Loading} from "../../../../Utils/Loading/Loading";
import ServerTime from "../OtherComponents/ServerTime";
import PdfReader from "./PdfReader";
import PageBreak from "./PageBreak";
import Restrictions from "./Restrictions/Restrictions";
import SwitchComponent from "./SwitchComponent";
import TableRenderingComponent from "./TableRenderingComponent/TableRenderingComponent";
import TreeComponent from "./TreeComponent/TreeComponent";

const CameraComponent = lazy(() => import('./CameraComponent'))
const Maps = lazy(() => import('./Maps'));
const ScreenList = lazy(() => import('./ListScreenComponent/ScreenList'))
const Calendar = lazy(() => import("../../../Calendar/Calendar"));

const RenderComponents = ({element, containerArrayPath, basePath, actionsContext, isTableCell}) => {
    function returnComponent() {
        switch (element.type) {
            case 'tabs':
                return <TabsScreenComponent
                    element={element}
                    containerArrayPath={containerArrayPath}
                />;
            case 'button':
                return <ButtonScreenComponent
                    element={element}
                    actionsContext={actionsContext}
                    isTableCell={isTableCell}
                />;
            case 'label':
                return <LabelScreenComponent
                    element={element}
                    actionsContext={actionsContext}
                />;
            case 'line':
                return <LineScreenComponent
                    element={element}
                />;
            case 'field':
                return <FieldScreenComponent
                    field={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                    basePath={basePath}
                />;
            case 'checkbox':
                return <CheckboxComponent
                    element={element}
                    actionsContext={actionsContext}
                    containerArrayPath={containerArrayPath}
                />
            case 'switch':
                return <SwitchComponent
                    element={element}
                    actionsContext={actionsContext}
                />
            case 'fieldArray':
                return <ContainerArrayFields
                    element={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                />;
            case 'fieldInfinity':
                return <FieldsInfinity
                    element={element}
                    containerArrayPath={containerArrayPath}
                />;
            case 'list':
                return <ScreenList
                    list={element}
                />;
            case 'image':
                return <ImageScreenComponent
                    element={element}
                    actionsContext={actionsContext}
                    containerArrayPath={containerArrayPath}
                />;
            case 'card':
                return <CardScreenComponent
                    element={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                />;
            case 'block':
                return <BlockScreenComponent
                    element={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                />;
            case 'chat':
                return <Chat
                    properties={element.properties}
                    styles={element.styles}
                />;
            case 'text':
                return <TextScreenComponent
                    properties={element.properties}
                    styles={element.styles}
                    actionsContext={actionsContext}
                    containerArrayPath={containerArrayPath}
                />;
            case 'section':
                return <PanelScreenComponent
                    panel={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                />;
            case 'panel':
                return <PanelScreenComponent
                    panel={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                />;
            case 'survey':
                return <Survey
                    surveyComponent={element}
                />;
            case 'embeddedScreen':
                return <EmbeddedScreen
                    screenId={element.properties ? element.properties.sourceId : ""}
                    styles={element.styles}
                    basePath={basePath ? basePath : element.properties.basePath}
                />;
            case 'stepper':
                return <StepperComponent
                    element={element}
                    containerArrayPath={containerArrayPath}
                    basePath={basePath}
                />;
            case 'progress':
                return <ProgressComponent
                    component={element}
                    actionsContext={actionsContext}
                />;
            case 'selectionCriteria':
                return <SelectionCriteria
                    component={element}
                    asComponent={true}
                />;
            case 'feed':
                return <Feed
                    component={element}
                />;
            case 'feedPost':
                return <FeedPost
                    component={element}
                />;
            case 'forEach':
                return <ForEachComponent
                    component={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                />;
            case 'actionsBar':
                return <ActionsBar component={element}/>;
            case 'bottomMenu':
                return <BottomMenu component={element}/>;
            case 'maps':
                return <Maps
                    component={element}
                    actionsContext={actionsContext}
                />;
            case 'dropzone':
                return <DropzoneComponent
                    component={element}
                    containerArrayPath={containerArrayPath}
                />
            case 'icon':
                return <IconComponent
                    component={element}
                    actionsContext={actionsContext}
                />
            case 'searchBar':
                return <SearchBarComponent
                    component={element}
                />
            case 'menu':
                return <Menu
                    component={element}
                    actionsContext={actionsContext}
                />
            case 'badge':
                return <BadgeComponent
                    component={element}
                    containerArrayPath={containerArrayPath}
                    actionsContext={actionsContext}
                />
            case 'rating':
                return <RatingComponent
                    component={element}
                    actionsContext={actionsContext}
                />
            case 'radioGroup':
                return <RadioGroupComponent
                    component={element}
                    actionsContext={actionsContext}
                />
            case 'swiper':
                return <SwiperComponent
                    component={element}
                />
            case 'accordion':
                return <AccordionComponent
                    component={element}
                    actionsContext={actionsContext}
                    containerArrayPath={containerArrayPath}
                />
            case 'options':
                return <OptionsComponent
                    component={element}
                    actionsContext={actionsContext}
                />
            case 'fullView':
                return <FullViewComponent
                    component={element}
                    actionsContext={actionsContext}
                />
            case 'calendar':
                return <Calendar/>
            case 'band':
                return <></>;
            case 'serverTime':
                return <ServerTime component={element}/>
            case 'camera':
                return <CameraComponent component={element}/>
            case 'pdfReader':
                return <PdfReader component={element}/>
            case 'pageBreak':
                return <PageBreak/>
            case 'restrictions':
                return <Restrictions component={element}/>
            case 'table':
                return <TableRenderingComponent
                    component={element}
                    actionsContext={actionsContext}
                    containerArrayPath={containerArrayPath}
                />
            case 'tree':
                return <TreeComponent
                    component={element}
                    actionsContext={actionsContext}
                />
            default:
                return <>undefined component {element.type}</>
        }
    }

    return (
        <React.Suspense fallback={<Loading/>}>
            {returnComponent()}
        </React.Suspense>
    )
};
export default RenderComponents

RenderComponents.propTypes = {
    element: PropTypes.object,
    containerArrayPath: PropTypes.string,
    basePath: PropTypes.string,
    actionsContext: PropTypes.object
};
